import history from '../history';
import { AUTH_TOKEN } from '../configs/AppConfig';
import { MENU_ITEMS, PERMISSION_METRICS, USER } from '../redux/constants/Auth';
import { RootContext } from '../context/RootContext';
import { useContext } from 'react';

export const logout = () => {
  // const ctx = useContext(RootContext);

  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(PERMISSION_METRICS);
  localStorage.removeItem(USER);
  localStorage.removeItem(MENU_ITEMS);
//   ctx.changeToken(null);
//   ctx.changePermission(null);
//   ctx.changeSideMenu(null);
  history.replace('/auth/login');
  window.location.reload(); // force clean app state
};
